import { ConfigProvider } from 'antd';
import 'App.css'
import browserHistory from 'browserHistory'
import { AuthProvider } from 'contexts/AuthContext'
import React from 'react'
import { Router } from 'react-router'
import ErrorBoundary from 'utils/ErrorBoundary'
import { getLocale } from 'utils/localeUtil'
import { getToken } from 'utils/localStorageUtils'
import { RoutesConfig } from './routes/Route'
import moment from 'moment';
import 'moment/locale/es';

const jwtToken = getToken()

const locale = getLocale()

moment.locale(locale.locale)

const App: React.FC = () => {
  return (
    <Router history={browserHistory}>
      <ConfigProvider locale={locale}>
        <ErrorBoundary>
          <AuthProvider token={jwtToken}>
            <RoutesConfig />
          </AuthProvider>
        </ErrorBoundary>
      </ConfigProvider>
    </Router>
  );
}

export default App
